﻿import * as Models from '../../models/models';
import * as _ from 'lodash';

export class AccountSummaryViewModel {
    public userProfile: Models.IUserProfile;
    public policyholder: Models.IPolicyholder;
    public billingStatement: Models.IBillingStatement;
    public submissions: Models.ISubmission[];
    public policies: Models.IPolicy[];
    public submissionStatus: string;

    public getPremiumTotal = (): string => {
        if (typeof (this.policies) !== "undefined") {
            const total = (this.policies.map((p) => { return p.writtenPremium; })).reduce((total, n) => { return total + n; });
            if (total === undefined) return "0";
            return total.toString();
        }
        return "0";
    }

    public isSubmissionStatusBound = (): boolean => {
        if (typeof (this.submissions) !== "undefined") {
            if (this.submissions.length > 0) {
                return this.submissions[0].statusCId === "141";
            }
        }
        return false;
    }

    public isBillingStatementAvailable = (): boolean => {

        let isAvailable: boolean = false;

        if (typeof (this.billingStatement) !== "undefined" && this.billingStatement) {
            isAvailable = true;
        }

        return isAvailable;
    }

    public isPastDue = (): boolean => {
        if (typeof (this.billingStatement) !== "undefined") {
            return this.billingStatement.pastDueBalance > 0;
        }
        return false;
    }

    public amountDueHeader = (): string => {
        if (this.isPastDue()) {
            return "Past Due Amount";
        } else {
            return "Amount Due";
        }
    }

    public amountDueValue = (): number => {

        if (typeof (this.billingStatement) !== "undefined") {
            if (this.isPastDue()) {
                return this.billingStatement.pastDueBalance;
            } else {
                return this.billingStatement.billedAndUnpaidBalance;
            }
        } else {
            return 0;
        }
    }

    public autoPayStatus = (): string => {

        if (typeof (this.policyholder) !== "undefined") {
            if (this.policyholder.autopay) {
                return "ON";
            } else {
                return "OFF";
            }
        } else {
            return "";
        }
    }
}
